import React from "react";

function Home() {
  return (
    <div className="page-container">
      {/* Header image */}
      <img
        src="./home/Home_header.png"
        alt="RTA 995 | MP 8995"
        className="header-img"
      />

      <h1 className="year-header">Winter 2024</h1>

      {/* 2x2 responsive grid */}
      <div className="square-photos">
        <img src="./home/MappingPlace.jpg" alt="MappingPlace" className="grid-img" />
        <img src="./home/ActivePathways.jpg" alt="ActivePathways" className="grid-img" />
        <img src="./home/TARA.jpg" alt="TARA" className="grid-img" />
        <img src="./home/MeTrA.jpg" alt="MeTrA" className="grid-img" />
      </div>

      {/* About section */}
      <h1 className="section-header">About the course:</h1>
      <p>
        Few digital technologies make use of the connection between our bodies
        and minds to support creativity and knowledge production. This research
        and design-centered course provides students with the unique
        opportunity to envision the shape of research-based education in digital
        and embodied media, while working in the Synaesthetic Media Lab (Synlab)
        on cutting-edge projects in Tangible and Embodied Interaction for
        creativity, discovery, and expression.
      </p>

      <p style={{ marginBottom: "30px" }}>
        Students in this course will develop the following skills:
      </p>

      {/* Skills section */}
      <h2>Evaluation</h2>
      <p>
        Analyze and critically evaluate existing tangible/embodied interaction
        systems using formal knowledge from the field.
      </p>

      <h2>Research</h2>
      <p>
        Formulate research questions, prepare a research plan, and carry out
        research in the area of tangible and embodied interaction design.
      </p>

      <h2>Design</h2>
      <p>
        Devise, design, develop, and evaluate tangible/embodied interaction
        systems and contextualize them within the field.
      </p>
    </div>
  );
}

export default Home;
